import React from "react";
import Select from "react-select";

const CustomStudentSelector = ({
  customStudentOptions,
  selectedStudents,
  onAddCustomStudents,
}) => {
  const handleChange = (selectedOptions) => {
    
    onAddCustomStudents(selectedOptions || []);
  };

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        Add Custom Students
      </label>
      <Select
        isMulti
        options={customStudentOptions}
        value={selectedStudents}
        onChange={handleChange}
        getOptionValue={(option) => option.value}
        getOptionLabel={(option) => option.label}
        placeholder="Search and add students..."
      />
    </div>
  );
};

export default CustomStudentSelector;
